import { Location } from 'vue-router'
import { ParticipantCollection as Collection } from '@/typings/api/Participant'
// eslint-disable-next-line object-curly-newline
import { COPY, createEdit, createView, DELETE, DOWNLOAD } from '@/helpers/enums/table-actions'
import { PARTICIPANTS_ROUTES as ROUTES } from './utils'


const getEditRoute = (data: Collection): Location => ({
  name: ROUTES.EDIT,
  params: { id: data.id.toString() },
})

const getViewRoute = (data: Collection): Location => ({
  name: ROUTES.VIEW,
  params: { id: data.id.toString() },
})

export const TABLE_ACTIONS_ADMIN = Object.freeze([
  DOWNLOAD,
  createView<Collection>(getViewRoute),
])

export const TABLE_ACTIONS = Object.freeze([
  ...TABLE_ACTIONS_ADMIN,
  createEdit<Collection>(getEditRoute),
  COPY,
  DELETE,
])

export const TABLE_HEADERS = Object.freeze([
  {
    text: 'ID',
    value: 'id',
    sortable: false,
    width: 60,
  },
  {
    text: 'Название',
    value: 'name',
    sortable: false,
  },
  {
    text: 'Кол-во пользователей',
    value: 'users_count',
    sortable: false,
    width: 170,
  },
  // {
  //   text: 'Кол-во объектов',
  //   value: 'counts',
  //   sortable: false,
  //   width: 200,
  // },
  // {
  //   text: 'Дата изменения',
  //   value: 'updated_at',
  //   sortable: false,
  //   width: 130,
  //   field: (value: Collection['updated_at']) => (
  //     value && dateFormatter(value)
  //   ),
  // },
])
